import { render, staticRenderFns } from "./ResidenciaProfesionalPage.vue?vue&type=template&id=2cdd9bcc&scoped=true&"
import script from "./ResidenciaProfesionalPage.vue?vue&type=script&lang=js&"
export * from "./ResidenciaProfesionalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd9bcc",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ResidenciaProfesionalPage.vue
// module id = 215
// module chunks = 8